// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__AZxSo","choiceBoxes":"toolbarselects_choiceBoxes__3YSdd","simpleField":"toolbarselects_simpleField__LMbqy"};